export default "__VITE_ASSET__DBHQ1PVw__"